import type {
  BillingOrderStatus,
  BillingPeriod,
  BillingProvider,
  BillingSettingsProvider
} from "@shudian/contracts";

export function billingOrderStatusLabel(status: BillingOrderStatus): string {
  switch (status) {
    case "pending":
      return "待支付";
    case "paid":
      return "已支付";
    case "cancelled":
      return "已取消";
    case "expired":
      return "已过期";
    case "failed":
      return "支付失败";
    case "refunded":
      return "已退款";
    default:
      return "未知状态";
  }
}

export function billingOrderStatusTone(
  status: BillingOrderStatus
): "success" | "warning" | "danger" | "info" | "neutral" {
  switch (status) {
    case "paid":
      return "success";
    case "pending":
      return "warning";
    case "failed":
      return "danger";
    case "refunded":
      return "info";
    case "cancelled":
    case "expired":
      return "neutral";
    default:
      return "neutral";
  }
}

export function billingPeriodLabel(period: BillingPeriod): string {
  switch (period) {
    case "monthly":
      return "月付";
    case "quarterly":
      return "季付";
    case "yearly":
      return "年付";
    default:
      return "未知周期";
  }
}

export function billingProviderLabel(provider: BillingProvider): string {
  switch (provider) {
    case "simulated":
      return "模拟支付";
    case "alipay":
      return "支付宝";
    default:
      return "未知渠道";
  }
}

export function billingSettingsProviderLabel(provider: BillingSettingsProvider): string {
  switch (provider) {
    case "disabled":
      return "停用";
    case "simulated":
      return "模拟支付";
    case "alipay":
      return "支付宝";
    default:
      return "未知渠道";
  }
}

export function formatCurrency(amount: number, currency: string): string {
  if (currency === "TWD") {
    return `NT$${amount.toLocaleString("zh-CN")}`;
  }
  return `${currency} ${amount.toLocaleString("zh-CN")}`;
}
